var map = {
	"./AP-StateMap.png": 71394,
	"./Abdulhakim.png": 58854,
	"./Abhishek_Lewis.png": 74267,
	"./Akshayakalpa-logo.png": 51111,
	"./AmulMicroATMDigitalPayments-1.png": 85459,
	"./Avdhoot_Bhogulkar.png": 61864,
	"./BOM.png": 83586,
	"./Bovine-insurance-logo desk.svg": 40487,
	"./Buyer.svg": 51119,
	"./BuyerIcon.png": 75129,
	"./CONNECT_COW.png": 51101,
	"./Call-Icon.png": 56987,
	"./Call_icon.png": 26009,
	"./Careers/CareersCarousal/CareerPage-Carousel1.png": 30824,
	"./Careers/CareersCarousal/CareerPage-Carousel2.png": 4495,
	"./Careers/CareersCarousal/CareerPage-Carousel3.png": 78844,
	"./Careers/CareersCarousal/CareerPage-Carousel4.png": 76521,
	"./Careers/LoadingIndicator.gif": 73606,
	"./Careers/Pragya.png": 97367,
	"./Careers/Rectangle 1357.png": 51080,
	"./Careers/Siddhi.png": 24826,
	"./Careers/at.svg": 84554,
	"./Careers/attachmentIcon.png": 97022,
	"./Careers/attachmentIcon.svg": 86916,
	"./Careers/career-w1.png": 40734,
	"./Careers/career-w2.png": 54880,
	"./Careers/career-w3.png": 41693,
	"./Careers/career-w4.png": 15928,
	"./Careers/employee1.png": 4402,
	"./Careers/employee2.png": 92363,
	"./Careers/employee3.png": 5481,
	"./Careers/employee4.png": 46575,
	"./Careers/perkLogo1.svg": 28700,
	"./Careers/perkLogo2.svg": 81421,
	"./Careers/perkLogo3.svg": 75185,
	"./Careers/perkLogo4.svg": 95550,
	"./Careers/perkLogo5.svg": 70447,
	"./Careers/perkLogo6.svg": 36639,
	"./Careers/perkLogo7.svg": 18368,
	"./Careers/perkLogo8.svg": 99003,
	"./Careers/perkLogo9.svg": 31623,
	"./Careers/redFlag.svg": 48411,
	"./Careers/testimonial_background.svg": 42121,
	"./Combined-Shape.svg": 99982,
	"./ConferenceKochi-1.png": 1853,
	"./ConferenceKochi-2.png": 280,
	"./ConferenceKochi-3.png": 70813,
	"./Connect1.png": 6716,
	"./Connect2.png": 25983,
	"./Connect3.png": 7036,
	"./Connect4.png": 24405,
	"./Connect5.png": 27750,
	"./Contact-us-hori-line.png": 17524,
	"./Contact-us-line.png": 14515,
	"./Contact_Us.png": 47334,
	"./Contact_us_mob.png": 32827,
	"./DBI Banner 1.png": 5073,
	"./DBI Banner 2.png": 98257,
	"./DBI Banner 3.png": 25099,
	"./DGV Connect - Mobile.gif": 78930,
	"./DGV Connect - Web.gif": 82322,
	"./DGV Pay Graphic mob.png": 5533,
	"./DGV Pay graphic.png": 13089,
	"./DGV-Group-Mob.png": 87536,
	"./DGV-Group-text-mob.png": 25815,
	"./DGV-Pay-Animation-Symbol.png": 79052,
	"./DGV-Pay-Mobile.gif": 48825,
	"./DGV-Qualify-Logo.png": 45831,
	"./DGV-Qualify-Newspaper-image.png": 21509,
	"./DGV-SaaS-image.png": 81498,
	"./DGV-group-Roadmap-Mob.svg": 46462,
	"./DGV-speaks-mobile.png": 32505,
	"./DGV-speaks.png": 2288,
	"./DGV.png": 87574,
	"./DGVAmulMicroATMSursagarLimbdi-1.png": 1230,
	"./DGVAmulMicroATMSursagarLimbdi-2.png": 65707,
	"./DGVAmulMicroATMSursagarLimbdi-3.png": 7525,
	"./DGVConnectTitle.png": 32902,
	"./DGVIcon.png": 59277,
	"./DGVMoneyLos-image.png": 34625,
	"./DGVMoneyLosImageDesk.png": 10008,
	"./DGVMoneyLosImageMob.png": 55484,
	"./DGVMoneyLosLogo.png": 59978,
	"./DGVMoneyMobile.gif": 95767,
	"./DGVMoneyWeb.gif": 52550,
	"./DGV_CONNECT_LOGO.png": 13205,
	"./DGV_White_LOGO.png": 33321,
	"./DGV_connect (2).png": 52954,
	"./DGV_connect.png": 95604,
	"./DGV_connect.svg": 65248,
	"./DGV_money (2).png": 96025,
	"./DGV_money.png": 54102,
	"./DGV_money.svg": 31193,
	"./DGV_money_banner.png": 45547,
	"./DGV_pay (2).png": 34039,
	"./DGV_pay.png": 53470,
	"./DGV_pay.svg": 83261,
	"./DGVicon.jpg": 43794,
	"./Dairy-Bovine-Loan.png": 89069,
	"./Dairy-Equipment-Loan.png": 68918,
	"./Dairy-Mentanance-Loan.png": 86296,
	"./Dairy-society-desk-1.png": 24330,
	"./Dairy-society-desk-2.png": 66736,
	"./Dairy-union-desk-1.png": 63659,
	"./DairyFarmer_desk_3.png": 28551,
	"./DairyFarmer_desk_4.png": 56117,
	"./DairyFarmer_mob-1.png": 26508,
	"./DairyFarmer_mob-2.png": 47262,
	"./DairyPartners/Dodla.png": 10087,
	"./DairyPartners/Gorakhnath.png": 48196,
	"./DairyPartners/asha.png": 40162,
	"./DairyPartners/kashi.png": 155,
	"./DairyPartners/maahi.png": 25671,
	"./Diamond.png": 95072,
	"./DubaiExpo2022-1-mob.png": 8821,
	"./DubaiExpo2022-1.png": 49642,
	"./DubaiExpo2022-2-mob.png": 60516,
	"./DubaiExpo2022-2.png": 4455,
	"./DubaiExpo2022-3-mob.png": 24451,
	"./DubaiExpo2022-3.png": 45866,
	"./Ellipse 187Strategic-partner-icon2.png": 47824,
	"./Email-Icon.png": 43698,
	"./Email_Icon.png": 33859,
	"./Group-BG.png": 82576,
	"./Group-connect-icon-mob.png": 24138,
	"./Group-connect-icon.png": 19214,
	"./Group-connect.png": 47163,
	"./Group-history-flow-bg.png": 48708,
	"./Group-insurance-icon.png": 29844,
	"./Group-insurance.png": 99141,
	"./Group-technology-icon.png": 14537,
	"./Group-technology.png": 13975,
	"./GroupHistory2019-new.png": 59161,
	"./GroupHistory2019.png": 32045,
	"./GroupHistory2020-new.png": 62086,
	"./GroupHistory2020.png": 37583,
	"./GroupHistory2021-new.png": 7185,
	"./GroupHistory2021.png": 38947,
	"./GroupHistory2022-2-new.png": 16222,
	"./GroupHistory2022-2.png": 45017,
	"./GroupHistory2022-new.png": 39153,
	"./GroupHistory2022.png": 37417,
	"./GroupHistory2023-2-new.png": 37095,
	"./GroupHistory2023-new.png": 65971,
	"./GroupHistory2023.png": 59984,
	"./GroupHistory2023_2.png": 66400,
	"./GroupHistory2024-2-new.png": 39317,
	"./GroupHistory2024-2.png": 38001,
	"./GroupHistory2024-new.png": 88947,
	"./GroupHistory2024.png": 12826,
	"./GujratStateMap.png": 97341,
	"./Hardeep_Singh.png": 22547,
	"./Harit_Pradesh-logo.png": 65533,
	"./IIDE2022DigivriddhiNeoBanking-1.png": 50312,
	"./Karnataka-StateMap.png": 75157,
	"./Karnataka-StateMap.svg": 83534,
	"./KarnatakaBankLogo.png": 27458,
	"./Landing-Application.png": 61053,
	"./LifeAtDgv/Celebration_1.png": 47854,
	"./LifeAtDgv/Celebration_2.png": 1087,
	"./LifeAtDgv/Celebration_3.png": 28028,
	"./LifeAtDgv/Celebration_4.png": 98002,
	"./LifeAtDgv/Ganesh-1.png": 88492,
	"./LifeAtDgv/Ganesh-2.png": 56656,
	"./LifeAtDgv/Ganesh-3.png": 99284,
	"./LifeAtDgv/Ganesh-4.png": 18740,
	"./LifeAtDgv/GaneshChaturthi-1.png": 20023,
	"./LifeAtDgv/GaneshChaturthi-2.png": 32749,
	"./LifeAtDgv/Office-1.png": 28322,
	"./LifeAtDgv/Office-2.png": 23245,
	"./LifeAtDgv/Office-3.png": 50574,
	"./LifeAtDgv/Office-4.png": 14442,
	"./LifeAtDgv/annual-sale-meet-22-23-1.png": 16429,
	"./LifeAtDgv/annual-sale-meet-22-23-2.png": 97075,
	"./LifeAtDgv/annual-sale-meet-22-23-3.png": 74180,
	"./LifeAtDgv/christmas-1.png": 83379,
	"./LifeAtDgv/christmas-2.png": 38834,
	"./LifeAtDgv/christmas-3.png": 7660,
	"./LifeAtDgv/dassehra-1.png": 62072,
	"./LifeAtDgv/dassehra-2.png": 8135,
	"./LifeAtDgv/dassehra-3.png": 4374,
	"./LifeAtDgv/dassehra-4.png": 91751,
	"./LifeAtDgv/dellaAdventure_1.png": 23223,
	"./LifeAtDgv/dellaAdventure_2.png": 86977,
	"./LifeAtDgv/dellaAdventure_3.png": 74167,
	"./LifeAtDgv/dellaAdventure_4.png": 39503,
	"./LifeAtDgv/diwali2023-1.png": 61251,
	"./LifeAtDgv/diwali2023-2.png": 98947,
	"./LifeAtDgv/fouthAnniversory24-1.png": 77602,
	"./LifeAtDgv/fouthAnniversory24-2.png": 49685,
	"./LifeAtDgv/fouthAnniversory24-3.png": 74134,
	"./LifeAtDgv/holi2024-1.png": 71182,
	"./LifeAtDgv/holi2024-2.png": 22907,
	"./LifeAtDgv/holi2024-3.png": 42612,
	"./LifeAtDgv/holi22-1.png": 21918,
	"./LifeAtDgv/holi22-2.png": 49148,
	"./LifeAtDgv/holi22-3.png": 96842,
	"./LifeAtDgv/lifeAtDgvCenter.png": 26050,
	"./LifeAtDgv/lifeAtDgvLeft.png": 2790,
	"./LifeAtDgv/lifeAtDgvRight.png": 24866,
	"./LifeAtDgv/mansoonTreck-1.png": 9118,
	"./LifeAtDgv/mansoonTreck-2.png": 805,
	"./LifeAtDgv/mansoonTreck-3.png": 23419,
	"./LifeAtDgv/newJoinees-1.png": 25946,
	"./LifeAtDgv/newJoinees-2.png": 29475,
	"./LifeAtDgv/newJoinees-3.png": 29163,
	"./LifeAtDgv/thirdAnniversary-1.png": 96634,
	"./LifeAtDgv/thirdAnniversary-2.png": 16878,
	"./LifeAtDgv/thirdAnniversary-3.png": 15762,
	"./LifeAtDgv/womensDay22-1.png": 40678,
	"./LifeAtDgv/womensDay22-2.png": 36609,
	"./LifeAtDgv/womensDay22-3.png": 22939,
	"./LifeAtDgv/womensDay24-1.png": 79102,
	"./LifeAtDgv/womensDay24-2.png": 83598,
	"./LifeAtDgv/womensDay24-3.png": 61140,
	"./Loan-for-bovine.png": 77836,
	"./Location-Icon.png": 64702,
	"./Location_Icon.png": 43182,
	"./MDEOfferings/MDE_Brochure.pdf": 84234,
	"./MDEOfferings/offering-CivilInfrastructure.png": 31710,
	"./MDEOfferings/offering-Design.png": 87776,
	"./MDEOfferings/offering-dairy.png": 77507,
	"./MDEOfferings/offerings-bovineBreed.png": 14268,
	"./MDEOfferings/offerings-hygienePractices.png": 99805,
	"./MDEOfferings/offerings-insurance.png": 19904,
	"./MDEOfferings/offerings-loanAssistance.png": 22485,
	"./MDEOfferings/offerings-location.png": 82043,
	"./MDEOfferings/offerings-milkingRoutine.png": 41413,
	"./MDEOfferings/offerings-nutrition.png": 32443,
	"./MDEOfferings/offerings-semenAssistance.png": 3796,
	"./MDEOfferings/offerings-transportation.png": 17770,
	"./MDEOfferings/offerings.png": 1730,
	"./MDEOfferings/offeringsbovineMarketplace.png": 31695,
	"./MDEOfferings/offeringsvetServices.png": 22539,
	"./MDE_popup_banner.png": 5864,
	"./MP-StateMap.png": 48985,
	"./Maalav-logo.png": 36762,
	"./Mayank_Rai.png": 78975,
	"./Mayur_Raval.png": 90472,
	"./MediaAndEvent/Events/Summit2025/media-certificate-mob.png": 15821,
	"./MediaAndEvent/Events/Summit2025/media-img2-mob.png": 39505,
	"./MediaAndEvent/Events/Summit2025/media-img3-mob.png": 15976,
	"./MediaAndEvent/MediaEventCarousal/media-mob1.png": 76004,
	"./MediaAndEvent/MediaEventCarousal/media-mob2.png": 49030,
	"./MediaAndEvent/MediaEventCarousal/media-mob3.png": 8473,
	"./MediaAndEvent/MediaEventCarousal/media-mob4.png": 72456,
	"./MediaAndEvent/MediaEventCarousal/media-web1.png": 83015,
	"./MediaAndEvent/MediaEventCarousal/media-web2.png": 57514,
	"./MediaAndEvent/MediaEventCarousal/media-web3.png": 34410,
	"./MediaAndEvent/MediaEventCarousal/media-web4.png": 20479,
	"./MediaAndEvent/MediaEventCarousal/media-web5.png": 93287,
	"./MediaAndEvent/MediaEventCarousal/media-web6.png": 6554,
	"./MediaAndEvent/MediaEventCarousal/media-web7.png": 37563,
	"./Meet-our-CEO.png": 74073,
	"./Mission-icon.png": 20418,
	"./Mission_and_Vision_mob_bg.png": 78246,
	"./MobHomeBanner1.png": 36356,
	"./MobHomeBanner3.png": 19203,
	"./Mob_DGV_connect.svg": 38928,
	"./Mob_DGV_money.svg": 28341,
	"./Mob_DGV_pay.svg": 5420,
	"./Mob_DGV_pay_new.svg": 67335,
	"./Money1.png": 1863,
	"./Money2.png": 83458,
	"./Money3.png": 19675,
	"./Money4.png": 3419,
	"./Mukesh_Ranjan.png": 9765,
	"./NDDB-logo.png": 30743,
	"./Nishchint_Paliwal.png": 20874,
	"./Osam-logo.png": 88694,
	"./PCI.png": 45737,
	"./Paayas-logo.png": 42260,
	"./Parikshit_Dubey.png": 38280,
	"./Partners-mob-1.png": 62897,
	"./Partners-mob-2.png": 60698,
	"./Partners-mob-3.png": 51153,
	"./Pay-ani.gif": 35828,
	"./Pay-machin-about-us.png": 40582,
	"./Pay1.png": 93974,
	"./Pay2.png": 59932,
	"./Pay3.png": 10576,
	"./Pay4.png": 66015,
	"./Pay5.png": 24463,
	"./PayMob1.png": 53261,
	"./PayMob2.png": 29161,
	"./PayMob3.png": 23759,
	"./PayMob4.png": 70784,
	"./PayMob5.png": 27499,
	"./Pratik_Poojari.png": 74406,
	"./Pushkar_Salunkhe.png": 94679,
	"./QRCode.png": 43653,
	"./QRConnectImg.png": 72965,
	"./RajasthanStateMap.png": 42101,
	"./Ravi_Singh.png": 42266,
	"./Rectangle-blue.png": 42642,
	"./Rectangle-blue1.png": 88630,
	"./Rectangle-mob-blue.png": 49764,
	"./Rectangle-mob-red.png": 52216,
	"./Rectangle-red.png": 52374,
	"./Rectangle-red1.png": 92931,
	"./RightArrow.png": 46423,
	"./Rohit_Mahakal.png": 53533,
	"./Romil_Gupta.png": 19717,
	"./Sangeetha_Lewis.png": 29505,
	"./Strategic-partner-icon1.png": 78637,
	"./Strategic-partner-icon10.png": 1696,
	"./Strategic-partner-icon11.png": 94851,
	"./Strategic-partner-icon12.png": 44944,
	"./Strategic-partner-icon13.png": 25183,
	"./Strategic-partner-icon14.png": 29376,
	"./Strategic-partner-icon2.png": 21938,
	"./Strategic-partner-icon3.png": 82154,
	"./Strategic-partner-icon4.png": 87293,
	"./Strategic-partner-icon5.png": 10846,
	"./Strategic-partner-icon6.png": 16648,
	"./Strategic-partner-icon7.png": 43911,
	"./Strategic-partner-icon8.png": 18132,
	"./Strategic-partner-icon9.png": 5963,
	"./Surya_Reddy.png": 52976,
	"./TamilNaduStateMap.png": 1854,
	"./Telangana-StateMap.png": 93379,
	"./UnionMinisterRupalaDGV-1-mob.png": 96706,
	"./UnionMinisterRupalaDGV-1.png": 75550,
	"./UnionMinisterRupalaDGV-2-mob.png": 88081,
	"./UnionMinisterRupalaDGV-2.png": 49952,
	"./UnionMinisterRupalaDGV-3-mob.png": 26775,
	"./UnionMinisterRupalaDGV-3.png": 55537,
	"./UpStateMap.png": 5702,
	"./Vijay_Chougle.png": 42042,
	"./Vision-&-Mission-bg.png": 8292,
	"./Vision-icon.png": 5862,
	"./Vision-img.png": 67641,
	"./Who we are images/BOD_ 1.png": 3630,
	"./Who we are images/BOD_ 2.png": 36948,
	"./Who we are images/BOD_ 3.png": 20388,
	"./Who we are images/BOD_image_2.png": 92564,
	"./Who we are images/BOD_image_3.png": 80522,
	"./Who we are images/BOD_image_4.png": 11798,
	"./Who we are images/BOD_image_5.png": 22195,
	"./Who we are images/BOD_image_6.png": 30297,
	"./Who we are images/BOD_image_7.png": 62487,
	"./Who we are images/BOD_image_8.png": 21965,
	"./Who we are images/BOD_logo_2.png": 12548,
	"./Who we are images/BOD_logo_3.png": 41282,
	"./Who we are images/BOD_logo_4.png": 41908,
	"./Who we are images/BOD_logo_5.png": 664,
	"./Who we are images/BOD_logo_6.png": 2107,
	"./Who we are images/BOD_logo_7.png": 37204,
	"./Who we are images/BOD_logo_8.png": 88307,
	"./Who we are images/Our-mission-logo.png": 78272,
	"./Who we are images/Our-vision-logo.png": 60937,
	"./Who we are images/certificate-1.png": 65716,
	"./Who we are images/certificate-2.png": 74793,
	"./Who we are images/certificate-3.png": 27050,
	"./Who we are images/desktop-sepuration-line.svg": 52587,
	"./Who we are images/director-image-1.png": 82775,
	"./Who we are images/director-logo-1.png": 55514,
	"./Who we are images/mobile-separation-line.svg": 33055,
	"./Who we are images/vision-mission-middle-line.png": 51963,
	"./Who we are images/who-we-are-carousel-1.png": 23080,
	"./Who we are images/who-we-are-carousel-1.svg": 16944,
	"./Who we are images/who-we-are-carousel-2.png": 62503,
	"./Who we are images/who-we-are-carousel-2.svg": 21581,
	"./Who we are images/who-we-are-carousel-3.png": 12310,
	"./Who we are images/who-we-are-carousel-3.svg": 82158,
	"./Who we are images/who-we-are-carousel-4.png": 35790,
	"./Who we are images/who-we-are-carousel-4.svg": 87995,
	"./amul_dairy.png": 41156,
	"./arrow.png": 74931,
	"./aruna.png": 13597,
	"./backgr_01.png": 54990,
	"./backgr_02.png": 92392,
	"./backgr_03.png": 91912,
	"./backgr_04.png": 73441,
	"./backgr_05.png": 47715,
	"./backgr_06.png": 50577,
	"./background-img.png": 70153,
	"./background.png": 69435,
	"./background_img.png": 35092,
	"./bankingPartner-1.png": 55068,
	"./bankingPartner-2.png": 68047,
	"./bankingPartner-3.png": 25160,
	"./bankingPartner-4.png": 88243,
	"./bankingPartner-5.png": 79080,
	"./banner1.png": 88945,
	"./banner2.png": 6556,
	"./bovine-feature-1.png": 71883,
	"./bovine-feature-2.png": 11146,
	"./bovine-feature-3.png": 37559,
	"./bovine-feature-4.png": 41729,
	"./bovine-feature-5.png": 69800,
	"./bovine-feature-logo-1.svg": 97637,
	"./bovine-feature-logo-2.svg": 7367,
	"./bovine-feature-logo-3.svg": 2521,
	"./bovine-feature-logo-4.svg": 33464,
	"./bovine-feature-logo-5.svg": 76695,
	"./bovine-feature-text-1.svg": 17198,
	"./bovine-feature-text-2.svg": 13563,
	"./bovine-feature-text-3.svg": 60174,
	"./bovine-feature-text-4.svg": 86845,
	"./bovine-feature-text-5.svg": 13926,
	"./bovine-footprint-1.png": 43114,
	"./bovine-footprint-2.png": 48584,
	"./bovine-footprint-3.png": 13732,
	"./capital_loan.svg": 45500,
	"./capital_loan_img.png": 48625,
	"./cattle_loan.svg": 446,
	"./cattle_loan_img.png": 31774,
	"./check-mark-meney-banner.svg": 5850,
	"./checklist-left-bottom.png": 81947,
	"./checklist-left-top.png": 15878,
	"./checklist-right-botton.png": 15967,
	"./checklist-right-top.png": 49091,
	"./clipboard.svg": 69502,
	"./close-black.svg": 95104,
	"./close-icon.png": 19638,
	"./connect-QR-code.png": 29152,
	"./connect-Rectangle.png": 60609,
	"./connect-check-mark.png": 40696,
	"./connect-feature-bg.png": 76755,
	"./connect-image-mob.png": 14597,
	"./connect-option-1.png": 69175,
	"./connect-option-2.png": 37139,
	"./connect-option-3.png": 29674,
	"./connect-option-4.png": 20474,
	"./connectImage.png": 186,
	"./contact-icon.png": 43233,
	"./contactUs-cin-bg-banner-horz.png": 38736,
	"./cow.png": 85019,
	"./daily-society-mob-1.png": 3645,
	"./daily-society-mob-2.png": 47761,
	"./dairy-bre-feature-1.png": 9554,
	"./dairy-bre-feature-2.png": 58408,
	"./dairy-bre-feature-3.png": 1539,
	"./dairy-bre-image.png": 96983,
	"./dairy-farmer-desk-2.png": 85509,
	"./dairy-farmer-desk-3.png": 39642,
	"./dairy-union-mob-1.png": 44999,
	"./dairy-union-mob-2.png": 82629,
	"./dairy-union-pertner-2.png": 62122,
	"./dairy-union-pertner-3.png": 80896,
	"./dairy-union-pertner-4.png": 33645,
	"./dairy-union-pertner-5.png": 50445,
	"./dairy_logo-1.png": 38278,
	"./dairy_logo-2.png": 39584,
	"./dairy_logo-3.png": 87317,
	"./dairy_logo-4.png": 99848,
	"./dgv-connect-m.png": 36098,
	"./dgv-connect.png": 18301,
	"./dgv-money-m.png": 77122,
	"./dgv-money-page-img-mob.png": 4330,
	"./dgv-money-page-img.png": 12749,
	"./dgv-money.png": 9383,
	"./dgv-pay.png": 46712,
	"./dgv5thAnnivercery-1.png": 5615,
	"./dgv5thAnnivercery-2.png": 72284,
	"./dgv5thAnnivercery-3.png": 31373,
	"./dgv5thAnnivercery-4.png": 64476,
	"./dgv5thAnnivercery-5.png": 84770,
	"./dgvAmulMicroATMLaunchSarvottamDairy-1-mob.png": 21762,
	"./dgvAmulMicroATMLaunchSarvottamDairy-1.png": 76507,
	"./dgvAmulMicroATMLaunchSarvottamDairy-2-mob.png": 93334,
	"./dgvAmulMicroATMLaunchSarvottamDairy-2.png": 7675,
	"./dgvAmulMicroATMLaunchSarvottamDairy-3-mob.png": 43896,
	"./dgvAmulMicroATMLaunchSarvottamDairy-3.png": 99039,
	"./dgvAmulMicroATMLaunchSarvottamDairy-new-3.png": 98833,
	"./dgvFirstInstitutionalFunding-1.png": 86516,
	"./dgvPlatformLaunchSarhadDairy-1-mob.png": 7570,
	"./dgvPlatformLaunchSarhadDairy-1.png": 61902,
	"./dgvPlatformLaunchSarhadDairy-2-mob.png": 83931,
	"./dgvPlatformLaunchSarhadDairy-2.png": 40404,
	"./dgvPlatformLaunchSarhadDairy-3-mob.png": 11695,
	"./dgvPlatformLaunchSarhadDairy-3.jpg": 96579,
	"./dgvSeriesAFunding-1.png": 1217,
	"./dgvServiceGujarat-1.png": 24813,
	"./dgv_money_banner_links.png": 62100,
	"./digital-dairy-loan.png": 17066,
	"./digitalBovineLoanJourneyRBI-1-mob.png": 61862,
	"./digitalBovineLoanJourneyRBI-1.png": 98761,
	"./digitalBovineLoanJourneyRBI-2-mob.png": 35394,
	"./digitalBovineLoanJourneyRBI-2.png": 32949,
	"./digitalBovineLoanJourneyRBI-3-mob.png": 61830,
	"./digitalBovineLoanJourneyRBI-3.png": 62889,
	"./digitalDairyLoansAMCSIntegration-1.png": 13298,
	"./digivriddhiSeriesAFundUsage-1.png": 81263,
	"./disbusment.png": 11021,
	"./disclaimer.png": 42461,
	"./distributionMeet_24-1.png": 23615,
	"./distributionMeet_24-2.png": 70459,
	"./distributionMeet_24-3.png": 49100,
	"./distributionMeet_24-4.png": 87401,
	"./email-Id-icon.png": 55378,
	"./errorIcon.png": 50996,
	"./facebook.svg": 3536,
	"./farmer.png": 90500,
	"./feature-bovine-mob-1.png": 34654,
	"./feature-dots-mob.png": 36470,
	"./feature-equipments-mob-1.png": 97996,
	"./feature-insurance-mob-1.png": 45592,
	"./feature-mob-1.png": 47046,
	"./feature-mob-2.png": 86862,
	"./feature-mob-3.png": 19684,
	"./feature-mob-4.png": 28856,
	"./features-icon-text-1.png": 3098,
	"./features-icon-text-2.png": 82935,
	"./features-icon-text-3.png": 83624,
	"./features-icon-text-4.png": 38147,
	"./federal_bank.png": 68253,
	"./fifth-Anniversery-celebration.mp4": 57142,
	"./fifthAnniversaaryCelebration-sliderImage.jpg": 81222,
	"./for-more-details-Bottom-line-mob.svg": 59382,
	"./for-more-details-bottom-line.svg": 62225,
	"./for-more-details-top-line.svg": 45695,
	"./forbesTop100DGV.png": 32664,
	"./gff2023Showcas-1.png": 70572,
	"./gff2023Showcase-2.png": 44141,
	"./gff2023Showcase-3.png": 63210,
	"./green_tick.svg": 45864,
	"./grievance-mob-middle-line.svg": 28243,
	"./grievance-mon-bottom-line.svg": 17280,
	"./grievance-redressal-bottom-line.svg": 56577,
	"./grievance-redressal-image.png": 33995,
	"./grievance-redressal-top-line.svg": 21314,
	"./grievance-redressal-ver-line.png": 47261,
	"./group-title-img-mob.png": 5951,
	"./group-title-img.png": 65294,
	"./gujarat_map.png": 65244,
	"./hamburgerClose.png": 80661,
	"./hamburgerFooterImg.png": 20501,
	"./hamburgerLines.png": 34985,
	"./hdfc_bank.png": 31140,
	"./home-gradient-mob-banner.png": 93925,
	"./home-slider3-mob.png": 7947,
	"./home-slider3-web.png": 77643,
	"./homeBanner-1.png": 7341,
	"./homeBanner-2.png": 33109,
	"./homeBannerLine.png": 87767,
	"./homeBanner_1.png": 41496,
	"./homeBanner_1_graddian.png": 48134,
	"./homeBanner_2.png": 51316,
	"./homeBanner_3.png": 92117,
	"./homeBanner_4.png": 11755,
	"./homeMobBanner_1.png": 22944,
	"./homeMobileBanner_2.png": 57537,
	"./homeMobileBanner_3.png": 95332,
	"./homeMobileBanner_4.png": 23388,
	"./hori-line.png": 11673,
	"./icon-close.png": 72513,
	"./icon-failure.png": 8331,
	"./icon-success.png": 39901,
	"./icon.png": 50286,
	"./icon1.png": 52486,
	"./icon2.png": 39016,
	"./icon3.png": 28234,
	"./icon4.png": 38183,
	"./icon5.png": 70250,
	"./idaDairyIndustryConference2023-1-mob.png": 77925,
	"./idaDairyIndustryConference2023-1.png": 13209,
	"./idaDairyIndustryConference2023-2-mob.png": 29642,
	"./idaDairyIndustryConference2023-2.png": 83922,
	"./idaDairyIndustryConference2023-3-mob.png": 88804,
	"./idaDairyIndustryConference2023-3.png": 66053,
	"./image 1.png": 49471,
	"./india_map_with_gujarat.png": 54412,
	"./infoedge_ventures.png": 49066,
	"./innovationDairyExpo2022Day2-1.png": 9654,
	"./insta.svg": 50995,
	"./insuarance-mob-checklist-task.png": 58233,
	"./insur-img-1.png": 15711,
	"./insur-img-2.png": 42296,
	"./insurance-Banner-mobile.png": 76207,
	"./insurance-banner-2.png": 45273,
	"./insurance-benefit-desk-1.png": 36812,
	"./insurance-benefit-desk-2.png": 5382,
	"./insurance-benefit-desk-3.png": 48778,
	"./insurance-benefit-desk-4.png": 13000,
	"./insurance-benefit-desk-5.png": 27569,
	"./insurance-benefit-desk-6.png": 32833,
	"./insurance-benefits-1.png": 52142,
	"./insurance-benefits-2.png": 76479,
	"./insurance-benefits-3.png": 28586,
	"./insurance-benefits-4.png": 27404,
	"./insurance-benefits-5.png": 96950,
	"./insurance-bg-image.png": 50074,
	"./insurance-image.png": 95850,
	"./insurance-mob-Group.png": 99767,
	"./insurance-mob-subject-banner.png": 9062,
	"./insurance-section-1.png": 42719,
	"./insurance-section-2.png": 6286,
	"./insurance-subject-layer.png": 85770,
	"./investmentInDGV-1.png": 65404,
	"./jersey.png": 32210,
	"./karnataka_bank.png": 12712,
	"./kcc_to_dairy.svg": 34400,
	"./kcc_to_dairy_img.png": 26973,
	"./left-arrow.png": 96936,
	"./leftArrow.png": 44448,
	"./lifeAtDgv-1.png": 3251,
	"./lifeAtDgv-2-slider.png": 21153,
	"./linkedin 1.svg": 79691,
	"./linkedin.png": 38518,
	"./mahakumbh24_1-mob.png": 60797,
	"./mahakumbh24_1.png": 30023,
	"./mahakumbh24_2-mob.png": 99928,
	"./mahakumbh24_2.png": 17605,
	"./mahakumbh24_3-mob.png": 57081,
	"./mahakumbh24_3.png": 39962,
	"./mahakumbh_24-1.png": 2546,
	"./mahakumbh_24-2.png": 50423,
	"./mahakumbh_24-3.jpg": 69032,
	"./mail-icon-background.png": 62839,
	"./mailicon.svg": 88471,
	"./map-info-logo-1.png": 71101,
	"./map-info-logo-2.png": 28520,
	"./map-info-logo-3.png": 48629,
	"./mde-bullets.png": 83494,
	"./mde_logo.png": 89521,
	"./mde_logo.svg": 69754,
	"./media1-mob1.png": 89426,
	"./media1-web1.png": 70668,
	"./media2-mob1.png": 2771,
	"./media2-web1.png": 44403,
	"./media3-web1.png": 38098,
	"./media4-web1.png": 88295,
	"./media_event_1.png": 39853,
	"./media_event_2.png": 35282,
	"./media_event_3.png": 74981,
	"./media_event_bharat_ke_innovators.png": 57020,
	"./media_event_bharat_ke_innovators_1.png": 96055,
	"./media_event_bharat_ke_innovators_2.png": 17112,
	"./media_event_maharastra_startup_of_week.png": 79884,
	"./media_event_startup_of_week_2025_1.png": 26493,
	"./media_event_startup_of_week_2025_2.png": 33128,
	"./media_event_startup_of_week_2025_3.png": 72601,
	"./media_event_startup_of_week_2025_mob_1.png": 54104,
	"./media_event_startup_of_week_2025_mob_2.png": 81271,
	"./media_event_startup_of_week_2025_mob_3.png": 9729,
	"./middle-image.png": 29523,
	"./milk_car.png": 66356,
	"./milk_union.png": 39290,
	"./mobHomeBanner4.png": 23934,
	"./mobHomeBanner5.png": 88131,
	"./mobile-gradient.png": 71373,
	"./mobile_disclaimer.png": 73802,
	"./mobile_hero_banner.png": 71406,
	"./money-los-feature-1.png": 53362,
	"./money-los-feature-2.png": 41217,
	"./money-los-feature-3.png": 28979,
	"./money-los-feature-mob-1.png": 58884,
	"./money-los-feature-mob-2.png": 65266,
	"./money-los-feature-mob-3.png": 85747,
	"./money-people-mob.png": 49751,
	"./money-people.png": 40877,
	"./monney-mobile-new.png": 90163,
	"./monney-mobile.png": 65877,
	"./muktaa.png": 15698,
	"./nasscomIndiaFintechAward2023-1-mob.png": 36047,
	"./nasscomIndiaFintechAward2023-1.png": 70984,
	"./nasscomIndiaFintechAward2023-2-mob.png": 52099,
	"./nasscomIndiaFintechAward2023-2.png": 74403,
	"./nasscomIndiaFintechAward2023-3-mob.png": 8290,
	"./nasscomIndiaFintechAward2023-3.png": 97911,
	"./network1.png": 8081,
	"./network2.png": 90943,
	"./network3.png": 97495,
	"./network4.png": 67710,
	"./network5.png": 94600,
	"./new-Insurance-Horizontal.png": 22336,
	"./new-bg-banner-desk.png": 36599,
	"./new-connect-logo.png": 92108,
	"./new-insurance-bg-banner.png": 34685,
	"./new-money-logo.png": 5126,
	"./newMobile.png": 4187,
	"./nextArrow.png": 66382,
	"./omidyar.png": 18318,
	"./omidyarFundingDGV.png": 71029,
	"./omidyarSeriesAFunding-1.png": 76215,
	"./omnivore.png": 76795,
	"./ourNetworkLine.svg": 11866,
	"./ourNetworkMobLine.svg": 98629,
	"./ournetworkLinemob.svg": 31076,
	"./partner-speak-partners-1.png": 36453,
	"./partner-speak-partners-2.png": 69779,
	"./partner-speak-partners-3.png": 35253,
	"./partner/dairyFarmers-1.png": 3000,
	"./partner/dairyFarmers-2.png": 20190,
	"./partner/dairySocieties-1.png": 15037,
	"./partner/dairySocieties-2.png": 51920,
	"./partner/dairyUnion-1.png": 61794,
	"./partner/dairyUnion-2.png": 76079,
	"./partner/dairyUnion-3.png": 61851,
	"./partner/dairyUnion-4.png": 41905,
	"./partner/lifeAtDgv-1.jpg": 20864,
	"./partner/lifeAtDgv-1.png": 3867,
	"./partner/lifeAtDgv-2.jpg": 38474,
	"./partner/lifeAtDgv-3": 12614,
	"./partner/lifeAtDgv-3.jpg": 95509,
	"./partner/partners_video_1.png": 59296,
	"./partner/partners_video_2.png": 5566,
	"./partner/partners_video_3.png": 17302,
	"./partnerAmulLogo.png": 28063,
	"./partnersBgImage.jpg": 80335,
	"./perks_banner_left.png": 85393,
	"./phone.png": 64050,
	"./play-video.png": 57980,
	"./prevArrow.png": 39286,
	"./profile-icon.png": 73169,
	"./qr-connect-mobiles.png": 25634,
	"./ragavan.png": 2247,
	"./ragavanVenkatesanSpeechIndiaInternationalDairyExpo2022-1-mob.png": 65426,
	"./ragavanVenkatesanSpeechIndiaInternationalDairyExpo2022-1.png": 22943,
	"./ragavanVenkatesanSpeechIndiaInternationalDairyExpo2022-2-mob.png": 3848,
	"./ragavanVenkatesanSpeechIndiaInternationalDairyExpo2022-2.png": 66593,
	"./ragavanVenkatesanSpeechIndiaInternationalDairyExpo2022-3-mob.png": 11515,
	"./ragavanVenkatesanSpeechIndiaInternationalDairyExpo2022-3.png": 52578,
	"./rajkotDairyCashDoorstep-1.png": 76802,
	"./rbiGovernorKPlecture-1.png": 32477,
	"./rbiGovernorKPlecture-2.png": 50198,
	"./rbiGovernorKPlecture-3.png": 49011,
	"./reihem.png": 39308,
	"./right-arrow.png": 50570,
	"./rupee.png": 2658,
	"./saas-mob-close-btn.png": 87070,
	"./saas-mob-open-btn.png": 64998,
	"./sabitha.png": 89173,
	"./saketh_vemu.png": 26855,
	"./seller.png": 81066,
	"./seller.svg": 35853,
	"./sellerIcon.png": 10031,
	"./sid_farm.png": 89466,
	"./slide2-checkbox.png": 14826,
	"./sowmiya.png": 33700,
	"./state vise map(india).jpg": 2921,
	"./subramanian.png": 32118,
	"./term_icon.svg": 927,
	"./term_loan_img.png": 50093,
	"./treasa.png": 7906,
	"./twitter 1.svg": 54416,
	"./twitter.png": 46737,
	"./vertical-line.png": 73383,
	"./videoPlayBTN.png": 96886,
	"./vishal_puri.png": 32793,
	"./visit-cin-ver-line.png": 30025,
	"./visitus-line.svg": 44606,
	"./webHomeBanner1.png": 21860,
	"./webHomeBanner3.png": 98726,
	"./webHomeBanner4.png": 33123,
	"./webHomeBanner5.png": 969,
	"./youTube.png": 47923,
	"./your_story_bharat_innovators.png": 94311
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;